import { Component } from 'react';

import AppInfo from '../app-info/app-info';
import SearchPanel from '../search-panel/search-panel';
import AppFilter from '../app-filter/app-filter';
import EmployeesList from '../employees-list/employees-list';
import EmployeesAddForm from    '../employees-add-form/employees-add-form';

import './app.css';

class App extends Component {
    constructor (props) {
        super(props)

        this.state = { 
            data: [
                {name: 'Johna S.', salary: 800, increase: false, rise: true, id: 1 },
                {name: 'SherilA M.', salary: 3500, increase: true, rise: false, id: 2 },
                {name: 'Adam S.', salary: 5000, increase: false, rise: false, id: 3 }
                ],
                term: '',
                filter: 'all'
        }  

        this.maxId = 4
    }

    deleteItem = (id) => {
        this.setState( ({ data }) => {
            return {
                data: data.filter( item => item.id !== id )
            }
        })
    }

    onChangeSalary = (id, salary) => {
        this.setState( ( { data } ) => ({
            data: data.map( (item) => {
                if (item.id === id) {
                    return {...item, salary: Number(salary)}
                }
                return item
            })            
        }))
    }

    addItem = (name, salary) => {
        const newItem = {
            name,
            salary,
            increase: false,
            rise: false,
            id: this.maxId++
        }
        this.setState( ({ data }) => {
            const newArr = [...data, newItem]
            return {
                data: newArr
            }
        })
    }

    onToggleProp = (id, prop) => {
        this.setState( ( { data }) => ({
            data: data.map( ( item ) => {
                if ( item.id === id ) {
                    return {...item, [prop]: !item[prop]}
                }
                return item
            })
        }))
    }

    searchEmp = (items, term) => {
        if (term === 0 ) {
            return items
        }
            return items.filter( item => item.name.indexOf(term) > -1 )
     }

    onUpdateSearch = (term) => {
        this.setState({term})
     }

    filterPost = (data, filter) => {
        switch (filter) {
            case 'rise':
                return data.filter( item => item.rise )
            case 'moreThen1000':
                return data.filter( item => item.salary > 1000)
            default:
                return data
        } 
    }

    onFilterSelect = (filter) => {
        this.setState({filter})
    }

    render() {
        const { data, term, filter } = this.state
        const emploees = this.state.data.length
        const increased = this.state.data.filter(item =>  item.increase).length
        const visibleData =  this.filterPost(this.searchEmp(data, term), filter)  

        return (
            <div className="app">
                <AppInfo emploees = {emploees} increased = {increased} />

                <div className="search-panel">
                    <SearchPanel onUpdateSearch = {this.onUpdateSearch} />
                    <AppFilter filter={filter} onFilterSelect={this.onFilterSelect}/>
                </div>

                <EmployeesList 
                    data={visibleData} 
                    onDelete= {this.deleteItem } 
                    onToggleProp = {this.onToggleProp}
                    onChangeSalary = {this.onChangeSalary}
                />
                <EmployeesAddForm 
                onAdd = {this.addItem} />
            </div>
        )
    }



}

export default App;